import DeliveryInfo from './DeliveryInfo';
export default DeliveryInfo;
